import store from '..';
import { Collector } from '../../models';
import { Collectors, SioBridge } from '../../services';
import { createRestSlices, applyReducers } from './rest';

const { initialState, getReducer, listReducer, getAction, listAction } = createRestSlices(Collectors);

const LOADING              = `kronos/collector/LOADING`;
const LOADING_SUCCESS      = `kronos/collector/LOADING_SUCCESS`;
const LOADING_FAILURE      = `kronos/collector/LOADING_FAILURE`;
const RESET                = 'kronos/collectors/RESET';
const FORGET               = 'kronos/collectors/FORGET';
const FORGET_SUCCEEDED     = 'kronos/collectors/FORGET_SUCCEEDED';
const FORGET_FAILED        = 'kronos/collectors/FORGET_FAILED';

const LOADING_COLLECTORS_SUCCESS = 'kronos/collectors/LOADING_ITEMS_SUCCESS';

const reducer = (state, action) => {
    switch (action.type) {
        case LOADING:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false,
            };
        case LOADING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false
            };
        case LOADING_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
            };
        case RESET:
            return {
                collectors: [],
                collector: null,
                ...state,
                isForgetting: false,
                successfullyForgot: false,
                failedToForget: false,
            };
        case LOADING_COLLECTORS_SUCCESS:
            return {
                ...state,
                isForgetting: false,
                successfullyForgot: false,
                failedToForget: false,
            };
        case FORGET:
            return {
                ...state,
                isForgetting: true,
                successfullyForgot: false,
                failedToForget: false,
            };
        case FORGET_SUCCEEDED:
            return {
                ...state,
                isForgetting: false,
                successfullyForgot: true,
                failedToForget: false,
            };
        case FORGET_FAILED:
            return {
                ...state,
                isLoadingOne: false,
                isForgetting: false,
                successfullyForgot: false,
                failedToForget: true,
            };
        default:
            return state;
    }
};

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [ getReducer, listReducer, reducer ]);
}

function loading() { return { type: LOADING } }
function loadingSuccess(status) { return { type: LOADING_SUCCESS, status } }
function loadingFailure(err) { return { type: LOADING_FAILURE, error: err } }

/* Export CRUD actions */
export const resetCollectors = () => dispatch => dispatch({ type: RESET });

export const forgetCollector = (collector, callback) => dispatch => {
    dispatch({ type: FORGET });
    Collectors.forget(collector)
        .then(result => {
            dispatch({
                type: FORGET_SUCCEEDED,
                result
            });
            callback && callback(/*err*/null, result);
        }).catch(error => {
            dispatch({
                type: FORGET_FAILED,
                error
            });
            callback && callback(error);
        });
}
export const loadCollector      = getAction;
export const loadCollectors     = listAction;
export const getCollectorStatus = (id) => {
    return (dispatch) => {
        dispatch(loading());
        return Collectors.getStatus(id)
            .then(data => {
                const status = { data };
                dispatch(loadingSuccess(status));
            })
            .catch(err => {
                dispatch(loadingFailure(err))
            });
    }
};
export const getCollectorStats = (id) => {
    return (dispatch) => {
        dispatch(loading());
        return Collectors.getStats(id)
            .then(data => {
                const stats = { data };
                dispatch(loadingSuccess(stats));
            })
            .catch(err => {
                dispatch(loadingFailure(err))
            });
    }
};

export const debit = (id, amount) => {
    return (_dispatch) => {
        return Collectors.debit(id, amount)
            .then(() => {
            })
            .catch(() => {
            });
    }
};

export const startChange = (id, amount) => {
    return (_dispatch) => {
        return Collectors.startChange(id, amount)
            .then(() => {
            })
            .catch(() => {
            });
    }
};

export const addChangeCoinsConfiguration = (id, coin, quantity) => {
    return (_dispatch) => {
        return Collectors.addChangeCoinsConfiguration(id, coin, quantity)
            .then(() => {
            })
            .catch(() => {
            });
    }
};

export const addChangeBillsConfiguration = (id, bill, quantity) => {
    return (_dispatch) => {
        return Collectors.addChangeBillsConfiguration(id, bill, quantity)
            .then(() => {})
            .catch(() => {
            });
    }
};

export const finishChange = (id) => {
    return (_dispatch) => {
        return Collectors.finishChange(id)
            .then(() => {
            })
            .catch(() => {
            });
    }
};

export const refund = (id, amount) => {
    return (_dispatch) => {
        return Collectors.refund(id, amount)
            .then(() => {
            })
            .catch(() => {
            });
    }
};

export const drainCoins = (id, coin, quantity) => {
    return (_dispatch) => {
        return Collectors.drainCoins(id, coin, quantity)
            .then(() => {
            })
            .catch(() => {
            });
    }
};

export const drainBills = (id, bill, quantity) => {
    return (_dispatch) => {
        return Collectors.drainBills(id, bill, quantity)
            .then(() => {})
            .catch(() => {
            });
    }
};

export const resetChest = (id) => {
    return (_dispatch) => {
        return Collectors.resetChest(id)
            .then(() => {
            })
            .catch(() => {
            });
    }
};

export const unloadCoins = (id, coin, quantity) => {
    return (_dispatch) => {
        return Collectors.unloadCoins(id, coin, quantity)
            .then(() => {
            })
            .catch(() => {
            });
    }
};

export const unloadBills = (id, bill, quantity) => {
    return (_dispatch) => {
        return Collectors.unloadBills(id, bill, quantity)
            .then(() => {})
            .catch(() => {
            });
    }
};

export const fillin = (id) => {
    return (_dispatch) => {
        return Collectors.fillin(id)
            .then(() => {})
            .catch(() => {
            });
    }
};

export const stopFillin = (id) => {
    return (_dispatch) => {
        return Collectors.stopFillin(id)
            .then(() => {})
            .catch(() => {
            });
    }
};

export const autotest = (id) => {
    return (_dispatch) => {
        return Collectors.autotest(id)
            .then(() => {
            })
            .catch(() => {
            });
    }
};

SioBridge.on('collectors_update', (data) => {
    let connectedCollectors = data.map(collector => new Collector(collector));

    const storeCollectors = (store.getState().collectors.collectors || []).map(collector => {
        collector.status = 'disconnected';
        connectedCollectors.forEach(connectedCollector => {
            if (connectedCollector._id === collector._id) {
                collector.status = 'connected';
                connectedCollectors = connectedCollectors.filter(connectedCollector => connectedCollector._id !== collector._id);
            }
        });

        return collector;
    });
    const collectors = storeCollectors.concat(connectedCollectors);
    store.dispatch({
        type: 'kronos/collectors/LOADING_ITEMS_SUCCESS',
        collectors
    });
});
